import React, { useEffect } from "react";
import Logo from "../../assets/img/Shiperone_Logo.svg";
// import { checkout, customerDetail } from "../../redux/actions/onboarding";
// import { useDispatch, useSelector } from "react-redux";
// import { useState } from "react";
// import { useLocation } from "react-router-dom";

function OnboardingSlide1({ page, setPage }) {

  // const dispatch = useDispatch();
  // const { company } = useSelector(state => state.auth)
  // const [url, setUrl] = useState(null)

  // const location = useLocation();
  // const state = location.state;

  // useEffect(() => {
  //   // if(!state?.payment || state?.payment !== "success"){

  //     const payload = {
  //       "current_plan_id": company.current_plan_id,
  //       "customer_id": company.stripe_customer_id
  //     }

  //     dispatch(customerDetail(company.stripe_customer_id, (data) => {
  //       if(data.status){
  //         if(data.data.subscriptions.total_count === 0){
  //           dispatch(checkout(payload, (data) => {
  //             console.log(data, data.status, data.data.url);
  //             if(data.status){
  //               // setUrl(data.data.url)
  //             }
  //           }));
  //         }
  //       }
  //     }))
  //   // }
  // }, [])

  return (
    <div
      className="space-y-4 xl:space-y-6 xl:pt-6 pt-5 h-full"
      style={{ maxHeight: "calc(100% - 42px)" }}
    >
      <div className="flex items-center justify-center">
        <div className="w-24">
          <img alt="Logo" src={Logo} className="object-cover" />
        </div>
      </div>
      <div className="flex justify-center items-center lg:h-1/2 2xl:h-[60%]">
        <div className="w-[80%] bg-[#F2F8FE] rounded-[20px] p-8 h-full flex justify-center items-center">
          <div>
            <p className="text-xl lg:text-2xl font-bold leading-10 tracking-tight text-center space-y-4 -mt-2 text-[#1E293B]">
              Welcome!
            </p>
            <p className="font-medium leading-7 tracking-tight text-center text-[#707070] mt-5 text-base lg:text-lg">
              We are happy to have you with us!
            </p>
            <p className="font-medium leading-7 tracking-tight text-center text-[#707070] text-base lg:text-lg">
              To prepare Shiperone Workflows for your specific needs please do
              our onboarding which will take around 7-8 minutes. If you want to
              do it another time simply come back later. You can also schedule a
              call with our product team to get you onboarded as smooth as
              possible.
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center space-x-16">
        <a
          href="https://meetings.hubspot.com/abidwai/shiperone-workflow-demo"
          target="__blank"
          className="btn bg-white border-slate-200 hover:border-slate-300 text-[#1E293B] text-[15px] leading-10 font-semibold cursor-pointer rounded-full w-[300px] h-[50px]"
        >
          Schedule Personal Onboarding
        </a>

        <button
          className="btn bg-[--bg-color-500] hover:bg-[--bg-color-600] text-white rounded-full font-semibold text-[15px] w-[300px] h-[50px]"
          onClick={() => setPage(page + 1)}
        >
          Start
        </button>
        {/* {
          url ? (
            <a
              href={url}
              target="_self"
              className="btn bg-[--bg-color-500] hover:bg-[--bg-color-600] text-white rounded-full font-semibold text-[15px] w-[300px] h-[40px] lg:h-[50px]"
            >
              Make Payment
            </a>
          ) : (
            <button
              className="btn bg-[--bg-color-500] hover:bg-[--bg-color-600] text-white rounded-full font-semibold text-[15px] w-[300px] h-[40px] lg:h-[50px]"
              onClick={() => setPage(page + 1)}
            >
              Start
            </button>
          )
        } */}
      </div>
    </div>
  );
}

export default OnboardingSlide1;
